import { useState, useEffect } from 'react';
import { authApi, getCachedUser, type AuthUser } from '../lib/api';

const ADMIN_EMAIL = 'contact@3dtovideo.com';

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  isAdmin: boolean;
}

export const useAuth = () => {
  const [authState, setAuthState] = useState<AuthState>(() => {
    // Optimistic hydration from localStorage to avoid flash
    const cached = getCachedUser();
    return {
      user: cached,
      loading: true,
      isAdmin: cached?.email?.toLowerCase() === ADMIN_EMAIL.toLowerCase(),
    };
  });

  useEffect(() => {
    let isMounted = true;

    const verify = async () => {
      const user = await authApi.getUser();

      if (!isMounted) return;

      if (!user) {
        setAuthState({ user: null, loading: false, isAdmin: false });
        return;
      }

      const isAdmin = user.email?.toLowerCase() === ADMIN_EMAIL.toLowerCase();
      setAuthState({ user, loading: false, isAdmin });
    };

    verify();

    return () => {
      isMounted = false;
    };
  }, []);

  return authState;
};
